import { makeSx } from '../theme/_utils'
import { defaultPalette } from '../theme/idsTheme'

export default makeSx({
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100dvh',
        width: '100dvw',
        background: defaultPalette.lightGrey.main,
    },
    containerInnerHeader: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1rem',
        marginBottom: '3rem',
        '& svg': {
            width: '14rem',
            height: 'auto',
        },
    },
    containerInner: {
        position: 'relative',
        width: 'fit-content',
        maxWidth: '100dvw',
        maxHeight: '75dvh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        background: '#ffffff',
        border: `2px solid ${defaultPalette.lightGrey.mediumLight}`,
        padding: '3rem 6rem 6rem',
        borderRadius: '1rem',
    },
    containerIconContainer: {
        position: 'absolute',
        bottom: '-2rem',
        left: 0,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem',
    },
    spaceCraft: {
        zIndex: 500,
        width: '5rem',
        height: '5rem',
        animationName: 'myEffect',
        animationDuration: '1.9s',
        animationTimingFunction: 'linear',
        animationDirection: 'normal',
        animationIterationCount: 'infinite',
        transform: 'translateY(0) rotate(-50deg)',
        fill: '#be2c6c',
    },
})
